import { axios } from '#api/axios';
import { useToast } from '#providers/ToastProvider';
import {
  UseMutateFunction,
  useMutation,
  useQueryClient
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useParams } from 'react-router';

const useThreadLikeMutations = <T extends boolean>(
  url: string,
  isLiked: T
): {
  likeMutate: UseMutateFunction<
    T extends false
      ? AxiosResponse<{ targetId: string; kind: string }>
      : AxiosResponse<string>,
    AxiosError,
    T extends false ? { targetId: string; kind: string } : string,
    unknown
  >;
} => {
  const { showToast } = useToast();
  const { id } = useParams();
  const queryClinet = useQueryClient();

  const { mutate } = useMutation<
    T extends false
      ? AxiosResponse<{ targetId: string; kind: string }>
      : AxiosResponse<string>,
    AxiosError,
    T extends false ? { targetId: string; kind: string } : string
  >({
    mutationFn: async payload => {
      if (isLiked) {
        return await axios.delete(`${url}/${payload}`);
      } else {
        return await axios.post(`${url}`, payload);
      }
    },
    onSuccess: () => {
      queryClinet.invalidateQueries({
        queryKey: ['get-qna-community-question-answer', id]
      });
    },
    onError: (e: AxiosError) => {
      if (e.response?.status === 401) {
        showToast({
          type: 'fail',
          message: '로그인이 필요합니다.'
        });
        return;
      }
      showToast({
        type: 'fail',
        message: '댓글 등록에 실패했습니다.'
      });
    }
  });

  return { likeMutate: mutate };
};

export default useThreadLikeMutations;
